import React from "react"
import { NavLink } from "react-router-dom"
import PrismancyLogo from './PrismancyLogo'

const CenteredHeader: React.FC = (): React.ReactElement => {
  return (
    <div className="ui-panel-header ui-layer-header relative mx-auto flex h-16 w-full items-center border-b border-border-default px-[28px]">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <NavLink to="/" className="flex leading-none">
          <PrismancyLogo variant="icon" />
        </NavLink>
      </div>
    </div>
  )
}

export default CenteredHeader
